module.exports = __webpack_public_path__ + "static/img/26.573064e5.jpg";